import Vue from 'vue'
import LoadScript from 'vue-plugin-load-script'
Vue.use(LoadScript)


let initialized = false

const initPromise = new Promise((resolve, reject) => {
    Vue.loadScript("//api.bitrix24.com/api/v1/")
    .then(() => {
        // eslint-disable-next-line no-undef
        resolve(BX24)
    })
    .catch(() => {
        reject('Failed to load BX24')
    })
})

export function init() {
    if (initialized) return initPromise
    initialized = true
    return initPromise
}

async function mountApp (args) {
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      BX24.callMethod('placement.bind', args, (e) => {
        if (e.status === 200) {
          resolve(e)
        } else { reject(e) }
      })
    })
  })
}

async function placementInfo () {
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      resolve(BX24.placement.info())
    })
  })
}

async function fitWindow(width, height){
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      resolve(BX24.resizeWindow(width, height))
    })
  })
}

async function unmountApp (args) {
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      BX24.callMethod('placement.unbind', args, (e) => {
        if (e.status === 200) {
          resolve(e)
        } else { reject(e) }
      })
    })
  })
}

async function mountUserField (args) {
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      BX24.callMethod('userfieldtype.add', args, (e) => {
        resolve(e)
      })
    })
  })
}

async function callMethod (method, args) {
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      BX24.callMethod(method, args, (e) => {
        resolve(e)
      })
    })
  })
}

// function asyncCallMethod(method, args){
//   return new Promise((resolve, reject))
// }

async function checkIsFields (placement) {
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      let placement_type = ''
      if(placement === 'CRM_DEAL_DETAIL_TAB'){
        placement_type = 'deal'
      } else if(placement === 'CRM_LEAD_DETAIL_TAB'){
        placement_type = 'lead'
      } else if(placement === 'CRM_LEAD_FIELDS'){
        placement_type = 'lead'
      } else if(placement === 'CRM_DEAL_FIELDS'){
        placement_type = 'deal'
      }
      BX24.callMethod('crm.'+placement_type+'.userfield.list', {}, (e) => {
        if (e.status === 200) {
          let obj = {}
          if(e.answer.result.find(field => field.FIELD_NAME === 'UF_CRM_TRK_TRACKER')){
            obj = {
              is_fields: true,
              placement_type: placement_type,
              fields: e.answer.result
            }
            resolve(obj)
          } else{
            obj = {
              placement_type: placement_type,
              is_fields: false
            }
            resolve(obj)
          }
        } else { reject(e) }
      })
    })
  })
}

async function unmountUserField (args) {
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      BX24.callMethod('userfieldtype.delete', args, (e) => {
        resolve(e)
      })
    })
  })
}

async function isMountedField () {
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      BX24.callMethod('userfieldtype.list', {}, (e) => {
        resolve(e)
      })
    })
  })  
}

async function isMountedApp () {
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      BX24.callMethod('placement.get', {}, (e) => {
        if (e.status === 200) {
          resolve(e)
        } else { reject(e) }
      })
    })
  })  
}

async function getAuthInfo () {
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      let auth_info = BX24.getAuth()
      resolve(auth_info)
    })
  })  
}


async function refreshAuthInfo(){
  const BX24 = await init()
  return new Promise((resolve, reject) => {
    BX24.init(() => {
      BX24.refreshAuth((e) => {
        resolve(e)
      })
    })
  })
}

export default {
  init,
  mountApp,
  mountUserField,
  isMountedApp,
  unmountApp,
  isMountedField,
  unmountUserField,
  callMethod,
  checkIsFields,
  placementInfo,
  getAuthInfo,
  refreshAuthInfo,
  fitWindow
}
